import { useState, useEffect } from 'react'
import { useMediaQuery, useTheme, Theme } from '@mui/material'

const useIsMobile = (): boolean => {
  const theme: Theme = useTheme()
  const isMobileQuery: boolean = useMediaQuery(theme.breakpoints.down('sm'))
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    setIsMobile(isMobileQuery)
  }, [isMobileQuery])

  return isMobile
}

export default useIsMobile
